import equal from "fast-deep-equal";

import { Card, Checkbox, Header } from "semantic-ui-react";

import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import updateDocument from "astrid-firestore/src/helpers/updateDocument";

import Table from "../../../../ui/components/Table/Table";

import usePriceTargets from "../../../hooks/usePriceTargets";

import usePriceTargetsTableColumns from "../hooks/usePriceTargetsTableColumns";

export default function PriceTargets({ price }) {
	const { type, producer, users, ref } = price;
	const { t } = useTranslation();

	const priceTargets = usePriceTargets({ type, producer: producer.id });
	const columns = usePriceTargetsTableColumns();

	const selectedRowIds = useMemo(() => users?.reduce((map, id) => ({ ...map, [id]: true }), {}) || {}, [users]);

	const onChange = useCallback((e, { checked }) => updateDocument(ref, { users: checked ? [] : null }), [ref]);

	const onSelectRows = useCallback(
		(rows) => {
			const next = rows.map(({ id }) => id);

			if (!equal(next, users)) {
				updateDocument(ref, { users: next });
			}
		},
		[ref, users],
	);

	const label = users ? t("availableForSome", "Available for some") : t("availableForAll", "Available for all");

	return (
		<>
			<Header as="h3">{t("availability", "Availability")}</Header>

			<Card fluid>
				<Card.Content>
					<Checkbox slider label={label} checked={!!users} onChange={onChange} />

					{users && (
						<Card.Content>
							<Table
								sortable
								selectable
								filterable
								pagination
								data={priceTargets}
								columns={columns}
								initialState={{ selectedRowIds }}
								onSelectRows={onSelectRows}
							/>
						</Card.Content>
					)}
				</Card.Content>
			</Card>
		</>
	);
}
